import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Select2 from "@Shared/components/inputs/select2";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentOperatorInput",
  components: {
    Select2
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    valueType: {
      type: String,
      required: true
    }
  },
  computed: {
    options() {
      return {
        minimumResultsForSearch: Infinity
      };
    },
    selectId() {
      return `operator-select-${this.index}`;
    }
  },
  methods: {
    formatFunction(data) {
      const formatMap = {
        number: this.formatData(data),
        date: this.formatDataDate(data)
      };
      return formatMap[this.valueType] || this.formatData(data);
    },
    formatData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, op => {
        const operatorText = {
          "=": this.$t("lists.segments.operators.is"),
          ">": this.$t("lists.segments.operators.largerThan"),
          "<": this.$t("lists.segments.operators.lessThan"),
          range: this.$t("lists.segments.operators.isBetween")
        };
        return {
          id: op,
          text: operatorText[op]
        };
      });
    },
    formatDataDate(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, op => {
        const operatorText = {
          "=": this.$t("lists.segments.operators.is"),
          ">": this.$t("lists.segments.operators.after"),
          "<": this.$t("lists.segments.operators.before"),
          range: this.$t("lists.segments.operators.isBetween")
        };
        return {
          id: op,
          text: operatorText[op]
        };
      });
    },
    handleChange(data) {
      this.$emit("change", data);
    }
  }
});